<template>
  <div
    class="flex flex-row gap-3 items-center fg-secondary text-style-xs font-medium"
  >
    {{ $t("pagination.items_per_page") }}
    <InputDropdown
      size="sm"
      side="top"
      v-model="perPageInputValue"
      :groups="[
        {
          options: perPageOptions.map((option) => ({
            value: option,
            label: option,
          })),
        },
      ]"
      :canClear="false"
      @update:model-value="handleUpdatePerPage"
    />
  </div>
</template>

<script setup>
// Vue utilities
import { ref } from "vue";

// Custom components
import { InputDropdown } from "@/SharedComponents/InputDropdown";

// Define Props
const props = defineProps({
  perPage: Number,
  perPageOptions: Array,
});

// Define Emits
const emit = defineEmits(["update:perPage"]);

// Refs
const perPageInputValue = ref([
  {
    value: props.perPage,
    label: props.perPage,
  },
]);

// Functions
const handleUpdatePerPage = (perPage) => {
  if (perPage[0]?.value !== props.perPage) {
    emit("update:perPage", perPage[0]?.value);
  }
};
</script>
